import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { log } from '@/utils/log'

export const VIEW_TYPE_QUERY_PARAM = 'viewType'
export const VIEW_TYPE_REVIEW = 'REVIEW'

export const useCourseNavigate = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const navigateToCourse = useCallback(
    (objectiveId: string, replace = true) => {
      // CourseDetailsPrefetcher
      navigate(`/courses/${objectiveId}/`, { replace, state: { from: location } })
      log('[useCourseNavigate] navigateToCourse')
    },
    [location, navigate],
  )

  const navigateToView = useCallback(
    (objectiveId: string, replace = false) => {
      // CourseView
      navigate(`/courses/${objectiveId}/view`, { replace, state: { from: location } })
      log('[useCourseNavigate] navigateToView')
    },
    [location, navigate],
  )

  const navigateToDetails = useCallback(
    (objectiveId: string, replace = false) => {
      // CourseDetails
      navigate(`/courses/${objectiveId}`, { replace, state: { from: location } })
      log('[useCourseNavigate] navigateToDetails')
    },
    [location, navigate],
  )

  const navigateToContent = useCallback(
    (objectiveId: string, isReview?: boolean, replace = false) => {
      const searchParams = new URLSearchParams(location.search)
      const query = Object.fromEntries(searchParams.entries())

      if (isReview) {
        query[VIEW_TYPE_QUERY_PARAM] = VIEW_TYPE_REVIEW
      }

      const queryStr = new URLSearchParams(query).toString()
      const toBeAppendedStr = queryStr ? `?${queryStr}` : ''

      navigate(`/courses/${objectiveId}/view/content${toBeAppendedStr}`, { replace, state: { from: location } })
      log('[useCourseNavigate] navigateToContent')
    },
    [location, navigate],
  )

  const navigateToActivityWorkflowView = useCallback(
    (objectiveId: string, activityWorkflowId: string) => {
      navigate(`/courses/${objectiveId}/workflow/${activityWorkflowId}/view`, { state: { from: location } })
      log('[useCourseNavigate] navigateToActivityWorkflowView')
    },
    [location, navigate],
  )

  return { navigateToCourse, navigateToView, navigateToDetails, navigateToContent, navigateToActivityWorkflowView }
}
